const errors = {
  500: {
    DEFAULT:
      'Sucedió un error desconocido al realizar la petición al servidor. Por favor contacte a soporte.'
  },
  401: {
    DEFAULT: 'Debe estar autenticado para poder acceder a este recurso',
    AUTH_TOKEN_COMPROMISED:
      'Su sesión ha sido usada en otro dispositivo y ha sido desactivada. Vuelva a iniciar sesión para ingresar nuevamente a la aplicación.',
    AUTH_INVALID_CREDENTIALS: 'Tu usuario o contraseña son incorrectos.',
    AUTH_TOKEN_EXPIRED: 'Su sesión a expirado o contraseña son incorrectos.'
  },
  404: {
    DEFAULT: 'El CAI no fue encontrado en el servidor',
    ACCOUNT_NOT_FOUND:
      'Lo sentimos, la cuenta de correo que ingresaste no existe.',
    INVALID_VERIFICATION_CODE: 'El código de verificación no es válido.'
  },
  403: {
    DEFAULT: 'No tienes permisos para realizar esta acción'
  },
  422: {
    DEFAULT: 'Existen errores en la forma',
    INVALID_PARAMETERS: 'Existen errores en la forma',
    ALREADY_EXISTS: 'Ya existe un recurso con el mismo nombre',
    YOU_HAS_BEEN_VALIDATED_YOUR_EMAIL: 'Tu email ya se encuentra validado.',
    INVALID_VERIFICATION_CODE: 'El código de verificación no es válido',
    NOT_ENOUGH_QUESTIONS:
      'Lo sentimos, este curso no cuenta con suficientes preguntas para realizar el examen.',
    MAX_ATTEMPTS_FOR_EXAM_COURSE:
      'Lo sentimos, has exedido el núemro de intentos para realizar este examen.',
    100: {
      DEFAULT:
        'Por favor, revisa que los campos del formulario sean correctos.',
      email: 'El correo electrónico que ingresaste ya se encuentra registrado'
    }
  }
}

const getError = (status, code = 'DEFAULT', fields = []) => {
  if (status == 422 && code == 100) {
    let _errors = []
    for (const field of fields) {
      const _field = errors[status][code][field.field] ? field.field : 'DEFAULT'
      _errors.push(errors[status][code][_field])
    }
    return _errors
  }
  const _status = errors[status] ? status : 0
  const _code = errors[_status][code] ? code : 'DEFAULT'
  return [errors[_status][_code]]
}

export default getError
